<div class="sidenav-container-outer">
	<div id="sidenav-items">
		<ng-container id="my-skills" *appRequiresPermission="'READ_MY'; entity: 'EMPLOYEE_SKILL'; idNotRelevant: true">
			@if (!deactivateSkillEdit && !isCustomerManager && !isExternal) {
				<div class="sidenav-nav-item">
					<a
						class="sidenav-nav-link"
						tabindex="0"
						(click)="openEditMySkills()"
						(keydown.enter)="openEditMySkills()"
						matTooltip="{{ 'mep.components.homescreen.edit-my-skills' | translate }}"
					>
						<mat-icon class="mep-icon-small" svgIcon="mep_edit_skills"></mat-icon>
						<span class="sidenav-link-text">
							{{ "mep.components.homescreen.edit-my-skills" | translate }}
						</span>
					</a>
				</div>
			}
		</ng-container>
		<ng-container id="my-profiles" *appRequiresPermission="'READ_MY'; entity: 'EMPLOYEE_SKILL'; idNotRelevant: true">
			@if (!isCustomerManager && !isExternal && applicationUser && applicationUser.employee) {
				<div class="sidenav-nav-item">
					<app-news-notification
						[messageKey]="'my-profiles.profile-generator-announcement'"
						[closeButtonKey]="'my-profiles.profile-generator-announcement.dismiss-button'"
						insertDate="07.10.2026"
						popoverPlacement="right"
					>
						<a
							class="sidenav-nav-link"
							tabindex="0"
							[routerLink]="'/my-profiles/' + applicationUser.employee.id"
							routerLinkActive="active"
							matTooltip="{{ 'mep.components.navigation.my-profiles-tooltip' | translate }}"
						>
							<mat-icon class="mep-icon-small" svgIcon="mep_profile"></mat-icon>
							<span class="sidenav-link-text">
								{{ "mep.components.navigation.my-profiles" | translate }}
							</span>
						</a>
					</app-news-notification>
				</div>
			}
		</ng-container>
		<ng-container id="my-data" *appRequiresPermission="'READ_MY'; entity: 'EMPLOYEE'; idNotRelevant: true">
			@if (applicationUser && applicationUser.employee) {
				<div class="sidenav-nav-item">
					<a
						class="sidenav-nav-link"
						[routerLink]="'/employee-edit/' + applicationUser.employee.id"
						routerLinkActive="active"
					>
						<div
							class="sidenav-tooltip"
							matTooltip="{{ 'mep.components.homescreen.edit-application-user' | translate }}"
						></div>
						<mat-icon class="mep-icon-small" svgIcon="mep_person"></mat-icon>
						<span class="sidenav-link-text">
							{{ "mep.components.homescreen.edit-application-user" | translate }}
						</span>
					</a>
				</div>
			}
		</ng-container>
		<mat-divider />
		<div id="employee-list" *appRequiresPermission="'READ_BU'; entity: 'EMPLOYEE'" class="sidenav-nav-item">
			<div class="sidenav-nav-collapsible">
				<a class="sidenav-nav-link" routerLink="/employee-list" routerLinkActive="active">
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.employee-list.homescreen-button' | translate }}"
					></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_user_group_2"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.employee-list.homescreen-button" | translate }}
					</span>
					<div
						class="expand-icon-container"
						tabindex="0"
						role="button"
						[attr.aria-label]="'mep.components.navigation.expand-button' | translate"
						(click)="toggleEmployeeMenu($event)"
						(keydown.enter)="toggleEmployeeMenu($event)"
					>
						<mat-icon color="primary" class="expand-icon" [class.expand-icon-expanded]="employeeExpanded">
							keyboard_arrow_down
						</mat-icon>
					</div>
				</a>
			</div>
			@if (sidenavStateExpanded && employeeExpanded) {
				<ul class="sublevel-nav">
					<ng-container *appRequiresPermission="'READ'; entity: 'ACTION_PLAN'">
						@if (actionPlanFunctionalityEnabled) {
							<div class="sublevel-nav-item">
								<a class="sublevel-nav-link" routerLink="/action-plan-list" routerLinkActive="active">
									<span class="sublevel-link-text">{{ "mep.document-titles.action-plan-list" | translate }}</span>
								</a>
							</div>
						}
					</ng-container>
				</ul>
			}
		</div>
		<ng-container id="project-list" *appRequiresPermission="'READ_BU'; entity: 'PROJECT'">
			<div class="sidenav-nav-item">
				<div class="sidenav-nav-collapsible">
					<a class="sidenav-nav-link" routerLink="/project-list" routerLinkActive="active">
						<div class="sidenav-tooltip" matTooltip="{{ 'mep.components.navigation.project-list' | translate }}"></div>
						<mat-icon class="mep-icon-small" svgIcon="mep_file"></mat-icon>
						<span class="sidenav-link-text">
							{{ "mep.components.navigation.project-list" | translate }}
						</span>
						<ng-container *appRequiresPermission="'READ'; entity: 'ASSIGNMENT'">
							<div
								class="expand-icon-container"
								[attr.aria-label]="'mep.components.navigation.expand-button' | translate"
								(click)="toggleProjectMenu($event)"
								tabindex="0"
								role="button"
								(keydown.enter)="toggleProjectMenu($event)"
							>
								<mat-icon color="primary" class="expand-icon" [class.expand-icon-expanded]="projectExpanded">
									keyboard_arrow_down
								</mat-icon>
							</div>
						</ng-container>
					</a>
				</div>
				@if (sidenavStateExpanded && projectExpanded) {
					<ul class="sublevel-nav">
						<div class="sublevel-nav-item" *appRequiresPermission="'READ'; entity: 'ASSIGNMENT'">
							<a class="sublevel-nav-link" routerLink="/project-total-capacities" routerLinkActive="active">
								<span class="sublevel-link-text">{{
									"mep.components.project-total-capacity.title" | translate
								}}</span>
							</a>
						</div>
						<div class="sublevel-nav-item" *appRequiresPermission="'UPDATE_BU'; entity: 'PROJECT'">
							<a
								class="sublevel-nav-link"
								(click)="openChangeProjectEndDialog()"
								tabindex="0"
								(keydown.enter)="openChangeProjectEndDialog()"
							>
								<span class="sublevel-link-text">
									{{ "mep.components.extend-or-move-project-dialog.heading" | translate }}
								</span>
							</a>
						</div>
						<div class="sublevel-nav-item" *appRequiresPermission="'UPDATE_BU'; entity: 'PROJECT'">
							<a
								class="sublevel-nav-link"
								(click)="openCopyAssignmentsDialog()"
								tabindex="0"
								(keydown.enter)="openCopyAssignmentsDialog()"
							>
								<span class="sublevel-link-text">{{
									"mep.components.copy-assignments-dialog.heading" | translate
								}}</span>
							</a>
						</div>
						<div class="sublevel-nav-item" *appRequiresPermission="'CREATE'; entity: 'ASSIGNMENT'">
							<a
								class="sublevel-nav-link"
								(click)="openAssignEmployeeDialog()"
								tabindex="0"
								(keydown.enter)="openAssignEmployeeDialog()"
							>
								<span class="sublevel-link-text">{{
									"mep.components.assigned-employees.homescreen-button" | translate
								}}</span>
							</a>
						</div>
						<div class="sublevel-nav-item" *appRequiresPermission="'READ'; entity: 'ASSIGNMENT'">
							<a class="sublevel-nav-link" routerLink="/my-projects" routerLinkActive="active">
								<span class="sublevel-link-text">{{ "mep.document-titles.my-projects" | translate }}</span>
							</a>
						</div>
					</ul>
				}
			</div>
		</ng-container>
		<div id="capa-list" *appRequiresPermission="'READ_BU'; entity: 'CAPACITY'" class="sidenav-nav-item">
			<a class="sidenav-nav-link" routerLink="/employee-capacities" routerLinkActive="active">
				<ng-container *appRequiresPermission="'READ_BU'; entity: 'EMPLOYEE'; else: noEmployeeNames">
					<div class="sidenav-tooltip" matTooltip="{{ 'mep.document-titles.employee-capacities' | translate }}"></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_graphic"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.document-titles.employee-capacities" | translate }}
					</span>
				</ng-container>
				<ng-template #noEmployeeNames>
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.employee-capacity-list.no-employee-names-title' | translate }}"
					></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_resource_search"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.employee-capacity-list.no-employee-names-title" | translate }}
					</span>
				</ng-template>
			</a>
		</div>
		<ng-container id="absence-list" *appRequiresPermission="'READ_MY'; entity: 'ABSENCE'; idNotRelevant: true">
			@if (showAbsenceLink) {
				<div class="sidenav-nav-item">
					<a class="sidenav-nav-link" routerLink="/absence-list" routerLinkActive="active">
						<div class="sidenav-tooltip" matTooltip="{{ 'mep.document-titles.absence-list' | translate }}"></div>
						<mat-icon class="mep-icon-small" svgIcon="mep_absence_list"></mat-icon>
						<span class="sidenav-link-text">
							{{ "mep.document-titles.absence-list" | translate }}
						</span>
					</a>
				</div>
			}
		</ng-container>
		<mat-divider />
		<div
			id="assign-employee"
			*appRequiresPermission="'CREATE_MY'; entity: 'ASSIGNMENT'; exactMatch: true; idNotRelevant: true"
			class="sidenav-nav-item"
		>
			<a class="sidenav-nav-link" (click)="openAssignEmployeeDialog(applicationUser.employee)">
				<div
					class="sidenav-tooltip"
					matTooltip="{{ 'mep.components.homescreen.create-assignment-for-application-user' | translate }}"
				></div>
				<mat-icon class="mep-icon-small" svgIcon="mep_project_assignment"></mat-icon>
				<span class="sidenav-link-text">
					{{ "mep.components.homescreen.create-assignment-for-application-user" | translate }}
				</span>
			</a>
		</div>
		<ng-container id="staffing-list" *appRequiresPermission="'READ'; entity: 'RESOURCE_REQUEST'">
			<div class="sidenav-nav-item">
				<a class="sidenav-nav-link" routerLink="/resource-request-list" routerLinkActive="active">
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.homescreen.resource-request' | translate }}"
					></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_staffing_request"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.homescreen.resource-request" | translate }}
					</span>
				</a>
			</div>
		</ng-container>
		<ng-container id="instance-wide-list" *appRequiresPermission="'READ'; entity: 'INSTANCE_WIDE_CAPACITY'">
			<div class="sidenav-nav-item">
				<a class="sidenav-nav-link" routerLink="/instance-wide-search" routerLinkActive="active">
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.sidenav.instance-wide-search' | translate }}"
					></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_world"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.sidenav.instance-wide-search" | translate }}
					</span>
				</a>
			</div>
		</ng-container>
		<mat-divider />
		<ng-container id="reports" *appRequiresPermission="'READ'; entity: 'REPORTS'">
			<div class="sidenav-nav-item">
				<a class="sidenav-nav-link" routerLink="/reports-screen" routerLinkActive="active">
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.breadcrumb./reports-screen' | translate }}"
					></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_checklist"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.breadcrumb./reports-screen" | translate }}
					</span>
				</a>
			</div>
		</ng-container>
		<mat-divider />
		<div id="skill-search" *appRequiresPermission="'READ'; entity: 'EMPLOYEE_WITHOUT_NAME'" class="sidenav-nav-item">
			<a class="sidenav-nav-link" routerLink="/skill-search" routerLinkActive="active">
				<div class="sidenav-tooltip" matTooltip="{{ 'mep.components.homescreen.skill-search' | translate }}"></div>
				<mat-icon class="mep-icon-small" svgIcon="mep_skill_search"></mat-icon>
				<span class="sidenav-link-text">
					{{ "mep.components.homescreen.skill-search" | translate }}
				</span>
			</a>
		</div>
		@if (showProfileMap) {
			<div id="profile-map" class="sidenav-nav-item">
				<a class="sidenav-nav-link" routerLink="/profilemap-iframe" routerLinkActive="active">
					<div
						class="sidenav-tooltip"
						matTooltip="{{ 'mep.components.homescreen.profile-map-tooltip' | translate }}"
					></div>
					<mat-icon class="profilemap-icon" svgIcon="profilemap"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.components.homescreen.profile-map" | translate }}
					</span>
				</a>
			</div>
		}
		@if (showChatBot) {
			<div id="chat-bot" class="sidenav-nav-item">
				<a class="sidenav-nav-link" routerLink="/chatbot" routerLinkActive="active">
					<div class="sidenav-tooltip" matTooltip="{{ 'mep.document-titles.chatbot' | translate }}"></div>
					<mat-icon class="mep-icon-small" svgIcon="mep_chatbot"></mat-icon>
					<span class="sidenav-link-text">
						{{ "mep.document-titles.chatbot" | translate }}
					</span>
				</a>
			</div>
		}
	</div>
	<div id="sidenav-buttons">
		<button
			[class.hidden]="!appearanceHelperZoomClass.isZoom()"
			id="zoom-button"
			class="sidenav-button"
			#zoomPopupController="mepPopover"
			[mepPopover]="zoomPopUp"
			[mepPopoverConfig]="{
				trigger: 'click',
				autoClose: 'outside',
				popoverClass: 'zoom-information-popover ngb-popover-no-zoom',
			}"
		>
			<span> {{ appearanceHelperZoomClass.zoom() * 100 }}% </span>
		</button>
		<ng-template #zoomPopUp>
			<h2 id="zoom-popup-header">
				{{ "mep.components.sidenav.zoom-popup.header" | translate }}
			</h2>
			<div id="zoom-popup-body">
				<div [innerHTML]="'mep.components.sidenav.zoom-popup.text-info' | translate"></div>
				<a
					(click)="appearanceHelperZoom.toggleZoom()"
					[innerHTML]="'mep.components.sidenav.zoom-popup.text-turn-off' | translate"
				></a>
				<div [innerHTML]="'mep.components.sidenav.zoom-popup.text-alternative' | translate"></div>
				<a
					rel="noreferrer"
					target="_blank"
					href="https://support.google.com/chrome/answer/96810"
					[innerHTML]="
						'mep.components.sidenav.zoom-popup.text-link'
							| translate: {link: 'https://support.google.com/chrome/answer/96810'}
					"
				></a>
			</div>
		</ng-template>
		<button class="sidenav-button" id="change-theme-button" (click)="appearanceHelperDarkMode.toggleColorTheme()">
			@if (appearanceService.config.darkMode() === darkModeSetting.DARK) {
				<mat-icon class="material-symbols-rounded dark-mode-change-icon"> dark_mode </mat-icon>
			}
			@if (appearanceService.config.darkMode() === darkModeSetting.AUTO) {
				<mat-icon class="material-symbols-rounded dark-mode-change-icon"> contrast </mat-icon>
			}
			@if (appearanceService.config.darkMode() === darkModeSetting.LIGHT) {
				<mat-icon class="material-symbols-rounded dark-mode-change-icon"> light_mode </mat-icon>
			}
			<span class="sidenav-link-text">
				{{ "mep.components.sidenav.color-scheme" | translate }}
			</span>
		</button>
	</div>
</div>
